import { message, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { Button, Col, Modal, Row, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import constants from '../../constants';
import authAxios from '../../authorization/axios';

interface Props {
  showSyncModal: boolean,
  onComplete: Function,
  refreshPage: Function,
  // tx: any
}

const  SyncTransactionForm  = ({
  showSyncModal,
  onComplete,
  refreshPage
  // tx
}: Props) => {
  const txMapper: { [key: string]: number | undefined } = {};

  const [isLoading, setIsLoading] = useState(false);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [showSyncModalState, setShowSyncModal] = useState(false);
  const [noSyncTrans, setNoSyncTrans] = useState(false);
  const [syncOrders, setSyncOrders] = useState([]);
  // const [syncOrder, setSyncOrder] = useState();

  console.log(showSyncModalState, showSyncModal);

  const { t } = useTranslation();

  const saveTransactions = () => {
    const body = Object.keys(txMapper).map((key: string) => {
      console.log(key);
      return { tx_id: key, fk_order: txMapper[key] };
    }).filter((b) => b.fk_order);
    onComplete();
    authAxios.put(constants.api.saveSyncOrders, body)
      .then(() => {
        message.success({
          content: `${t('TRANSACTIONS_UPDATE')}`,
          duration: 2,
          style: {
            marginTop: 100
          }
        }).then(() => { refreshPage(); });
      })
      .catch(() => {
        message.success({
          content: `${t('NO_TRANSACTIONS')}`,
          duration: 2,
          style: {
            marginTop: 100
          }
        }).then(() => { refreshPage(); });
      });
  };


  const getSyncOrders = async () => {
    if (fromDate && toDate) {
      const orders = await authAxios.get(`${constants.api.getSyncOrders}?from=${fromDate}&to=${toDate}`);
      if (orders?.data?.data) {
        setSyncOrders(orders?.data?.data);
        setNoSyncTrans(false);
        setIsLoading(false);
      } else {
        setNoSyncTrans(true);
        setIsLoading(false);
      }
      syncOrders.map((so: any) => {
        txMapper[so.tx] = so.orders.length > 1 ? undefined : so.orders[0].id;
        return so;
      });

      if (!syncOrders.find((so: any) => so.orders?.length > 1)) {
        saveTransactions();
      }
    }
  };


  useEffect(() => { getSyncOrders(); }, []);


  return <div>
      {isLoading && <div className='fullscreen backdrop'>
        <Spinner animation='border' role='status' variant={'light'}>
          <span className='sr-only'>{t('LOADING')}...</span>
        </Spinner>
      </div>}
      <Modal.Header closeButton>
        <Modal.Title>{t('SYNCHRONIZE_TRANSACATIONS')}</Modal.Title>
      </Modal.Header>

      <Modal.Body >
        <Row>
          <Col md='5'>
            <span>{t('FROM')}</span>
          </Col>
          <Col md='5'>
            <span>{t('TO')}</span>
          </Col>
        </Row>
        <Row>
          <Col md='4'>
            <input style={{ height: 40 }} onChange={(e: any) =>  setFromDate(e.target.value)}
              type="date" id="start" name="trip-start"
              value={fromDate} />
          </Col>
          <Col md='4'>
            <input style={{ height: 40 }} onChange={(e: any) => setToDate(e.target.value)}
              type="date" id="start" name="trip-start"
              value={toDate} />
          </Col>
          <Col md='2'>
            <Button variant="primary" onClick={() => {
              setIsLoading(true); getSyncOrders();
            }}>{t('GO')}</Button>
          </Col>
        </Row>
        {syncOrders && <Row style={{ backgroundColor: 'yellow', marginTop: 10 }}>
          <Col md='1'>
          </Col>
          <Col md='7'>
            {t('TX ID')}
          </Col>
          <Col>
            {t('ORDER_ID')}
          </Col>
        </Row>}
        <div style={{ maxHeight: '500px', overflow: 'hidden', overflowY: 'scroll' }}>
          {syncOrders?.filter((so: any) => so.orders.length > 1)
            .map((item: any, index: number) => <div key={item.tx} style={{ marginTop: 10 }}>
              <Row key={item.tx}>
                <Col md='1'>
                  <Button variant="light" onClick={() => {
                    const newSyncOrder = syncOrders.splice(index, 1);
                    delete txMapper[item.tx];
                    setSyncOrders(newSyncOrder);
                    // setSyncOrder(newSyncOrder); ????
                    // this.setState({ syncOrder: newSyncOrder });
                  }}>{t('X')}</Button>
                </Col>
                <Col md='7'>
                  <span>{item.tx}</span>
                </Col>
                <Col md='3'>
                  <Select style={{ width: '100%' }} onChange={(value) => {
                    txMapper[item.tx] = value;
                  }}
                    defaultValue={item?.orders[1]?.id ? '' : item.orders[0]?.id}>
                    {item.orders.map((order: any) => <Select.Option
                      key={order.id}
                      value={order.id}>
                      {order.order_id}
                    </Select.Option>)}
                  </Select>
                </Col>
              </Row>
            </div>)}
        </div>
        {noSyncTrans &&
          <b style={{ textTransform: 'uppercase' }}> {t('NO_SYNC_TRANS')}</b>}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => setShowSyncModal(false)}
        >
          {t('CANCEL')}
        </Button>
        <Button variant="primary"
          onClick={() => {
            setIsLoading(true);saveTransactions();
          }
          }>
          {t('SYNC')}
        </Button>
      </Modal.Footer>

    </div>;
};

export default SyncTransactionForm;